/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextVariableFontSettingsIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Variable Font Settings',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.25,15.27148h-7.6687c-.34064-1.43018-1.62128-2.5-3.15405-2.5s-2.81342,1.06982-3.15405,2.5H1.75c-.41406,0-.75.33594-.75.75s.33594.75.75.75h2.52319c.34064,1.43018,1.62128,2.5,3.15405,2.5s2.81342-1.06982,3.15405-2.5h7.6687c.41406,0,.75-.33594.75-.75s-.33594-.75-.75-.75ZM7.42725,17.77148c-.96484,0-1.75-.78516-1.75-1.75s.78516-1.75,1.75-1.75,1.75.78516,1.75,1.75-.78516,1.75-1.75,1.75Z"
      fill="currentColor"
    />
    <path
      d="M7.25,2H2.75c-.96484,0-1.75.78516-1.75,1.75v.25c0,.41406.33594.75.75.75s.75-.33594.75-.75v-.25c0-.1377.1123-.25.25-.25h1.5v6h-.36621c-.41406,0-.75.33594-.75.75s.33594.75.75.75h2.2002c.41406,0,.75-.33594.75-.75s-.33594-.75-.75-.75h-.33398V3.5h1.5c.1377,0,.25.1123.25.25v.25c0,.41406.33594.75.75.75s.75-.33594.75-.75v-.25c0-.96484-.78516-1.75-1.75-1.75Z"
      fill="currentColor"
    />
    <path
      d="M16.75,2h-4.5c-1.24072,0-2.25,1.00977-2.25,2.25v.25c0,.55273.44775,1,1,1s1-.44727,1-1v-.25c0-.1377.1123-.25.25-.25h1.01715c-.00208.02979-.01715.05469-.01715.08496v4.91504h-.25c-.55225,0-1,.44727-1,1s.44775,1,1,1h3c.55225,0,1-.44727,1-1s-.44775-1-1-1h-.25v-4.91504c0-.03027-.01508-.05518-.01715-.08496h1.01715c.1377,0,.25.1123.25.25v.25c0,.55273.44775,1,1,1s1-.44727,1-1v-.25c0-1.24023-1.00928-2.25-2.25-2.25Z"
      fill="currentColor"
    />
  </svg>`;
};
